export enum DETAILS {
  PAYMENT_METHODS = 'Payment methods',
  SOLD_TO_ADDRESSES = 'Sold-to addresses',
  BILLING_ADMINS = 'Billing admins',
  DISCOUNT = 'Discounts',
  AUDIT_TRAIL = 'Audit trail',
  EMAILS = 'Emails',
  ORDER_HISTORY = 'Order history',
  ADMINS = 'Admins',
  DETAILS = 'Details',
}

export const PAYMENT_METHOD_NOT_ASSOCIATED =
  'This payment method is not associated with any other billing profiles. Removing it won’t affect any other billing profile.';

export const ASSOCIATED_PAYMENT_METHOD =
  'This payment method is currently linked to one or more billing profiles. To continue, remove this payment method from the billing profiles listed below.';

export const ASSOCIATED_PAYMENT_METHOD_REMOVE =
  'You’ll need to remove or change the payment method for the following billing profiles before removing it from your billing account.';
